(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
const initBundleBuilder = (root) => {
  if (!root || root.dataset.bound === 'true') return;
  root.dataset.bound = 'true';

  const minimum = parseInt(root.dataset.minimum, 10) || 2;
  const requiredQuantityEnabled = root.dataset.requiredQuantity === 'true';
  const openAt = parseInt(root.dataset.openAt, 10) || minimum;
  const lines = root.querySelector('[data-bundle-lines]');
  const status = root.querySelector('[data-bundle-status]');
  const progress = root.querySelector('[data-bundle-progress]');
  const meter = root.querySelector('[data-bundle-meter]');
  const total = root.querySelector('[data-bundle-total]');
  const submit = root.querySelector('[data-bundle-submit]');
  const submitLabel = root.querySelector('[data-bundle-submit-label]');
  const error = root.querySelector('[data-bundle-error]');
  const offer = root.querySelector('.bundle-builder__offer');
  const panel = root.querySelector('.bundle-builder__panel');
  const toggle = root.querySelector('[data-bundle-toggle]');
  if (!lines || !submit) return;

  const selected = new Map();
  let lastCount = 0;
  const cartUrl = root.dataset.cartUrl || root.dataset.cartUrlFallback || '/cart/add.js';
  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isMobile = () => window.matchMedia('(max-width: 699px)').matches;

  const setPanelOpen = (open) => {
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const money = (cents) => {
    if (typeof window.customFormatMoney === 'function') return window.customFormatMoney(cents);
    return (cents / 100).toFixed(2);
  };

  const readVariant = (card) => {
    const field = card.querySelector('[data-variant-select]');
    if (!field) return null;
    if (field.tagName === 'SELECT') {
      const option = field.options[field.selectedIndex];
      if (!option) return null;
      return {
        id: parseInt(option.value, 10),
        price: parseInt(option.dataset.price, 10) || 0,
        compare: parseInt(option.dataset.compare, 10) || 0,
        available: option.dataset.available === 'true',
        image: option.dataset.image || '',
        variantTitle: option.textContent.trim()
      };
    }
    return {
      id: parseInt(field.value, 10),
      price: parseInt(field.dataset.price, 10) || 0,
      compare: parseInt(field.dataset.compare, 10) || 0,
      available: field.dataset.available === 'true',
      image: field.dataset.image || '',
      variantTitle: ''
    };
  };

  const paintCard = (card) => {
    const variant = readVariant(card);
    if (!variant) return;
    const price = card.querySelector('[data-card-price]');
    const compare = card.querySelector('[data-card-compare]');
    const image = card.querySelector('[data-card-image]');
    const button = card.querySelector('[data-bundle-add]');
    if (price) price.textContent = money(variant.price);
    if (compare) {
      if (variant.compare > variant.price) {
        compare.hidden = false;
        compare.textContent = money(variant.compare);
      } else {
        compare.hidden = true;
        compare.textContent = '';
      }
    }
    if (image && variant.image) image.src = variant.image;
    const item = selected.get(card.dataset.blockId);
    if (item) {
      item.id = variant.id;
      item.price = variant.price;
      item.image = variant.image || item.image;
      item.available = variant.available;
      if (!variant.available) selected.delete(card.dataset.blockId);
    }
    if (button && !selected.has(card.dataset.blockId)) {
      button.disabled = !variant.available;
      button.textContent = variant.available ? root.dataset.labelAdd : root.dataset.labelSoldOut;
    }
  };

  const render = () => {
    lines.replaceChildren();
    let count = 0;
    let amount = 0;
    selected.forEach((item, blockId) => {
      const floor = Math.max(1, item.required || 1);
      item.quantity = Math.max(floor, Math.min(10, item.quantity));
      count += item.quantity;
      amount += item.price * item.quantity;
      const row = document.createElement('li');
      row.className = 'bundle-builder__line';
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.width = 56;
        img.height = 56;
        row.append(img);
      }
      const copy = document.createElement('div');
      const title = document.createElement('p');
      title.className = 'bundle-builder__line-title';
      title.textContent = item.title;
      const actions = document.createElement('div');
      actions.className = 'bundle-builder__line-actions';
      const qty = document.createElement('div');
      qty.className = 'bundle-builder__qty';
      const decrease = document.createElement('button');
      decrease.type = 'button';
      decrease.dataset.qty = 'decrease';
      decrease.dataset.blockId = blockId;
      decrease.textContent = '-';
      decrease.disabled = item.quantity <= floor;
      decrease.setAttribute('aria-label', root.dataset.labelDecrease || '');
      const value = document.createElement('span');
      value.textContent = String(item.quantity);
      const increase = document.createElement('button');
      increase.type = 'button';
      increase.dataset.qty = 'increase';
      increase.dataset.blockId = blockId;
      increase.textContent = '+';
      increase.setAttribute('aria-label', root.dataset.labelIncrease || '');
      qty.append(decrease, value, increase);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'bundle-builder__remove';
      remove.dataset.remove = blockId;
      remove.textContent = root.dataset.labelRemove || '';
      actions.append(qty, remove);
      copy.append(title, actions);
      row.append(copy);
      lines.append(row);
    });

    const goal = Math.max(minimum, count);
    if (progress) {
      progress.textContent = (root.dataset.labelProgress || '__COUNT__ / __MINIMUM__')
        .replace('__COUNT__', String(count))
        .replace('__MINIMUM__', String(goal));
    }
    if (meter) meter.style.width = `${Math.min(count / minimum, 1) * 100}%`;
    if (status) {
      const remaining = Math.max(minimum - count, 0);
      status.textContent = remaining === 0
        ? root.dataset.labelReady
        : (root.dataset.labelAddMore || '').replace('__COUNT__', String(remaining));
    }
    if (offer) offer.hidden = count >= minimum;
    if (total) total.textContent = money(amount);
    const ready = count >= minimum && selected.size > 0;
    submit.disabled = !ready || submit.dataset.loading === 'true';
    root.querySelectorAll('[data-bundle-card]').forEach((card) => {
      const button = card.querySelector('[data-bundle-add]');
      const on = selected.has(card.dataset.blockId);
      card.classList.toggle('is-selected', on);
      if (!button) return;
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.classList.toggle('is-added', on);
      if (on) button.textContent = root.dataset.labelAdded;
    });

    const openThreshold = requiredQuantityEnabled ? openAt : minimum;
    if (isMobile() && lastCount < openThreshold && count >= openThreshold) {
      setPanelOpen(true);
    }
    lastCount = count;
  };

  const updateCartUi = async () => {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('change:cart'));
    try {
      const cartResponse = await fetch(`${rootUrl}cart.js`);
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      document.querySelectorAll('cart-count, [data-cart-count], .cart-count, .header__cart-count, .cart-bubble__quantity').forEach((node) => {
        node.textContent = cart.item_count;
        node.classList.remove('opacity-0');
      });
    } catch (cartError) {
      // Keep going so the drawer can still open.
    }
  };

  const openCartDrawer = () => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    if (typeof drawer.show === 'function') {
      drawer.show();
      return;
    }
    drawer.dispatchEvent(new Event('open', { bubbles: true }));
  };

  root.addEventListener('click', (event) => {
    const toggleBtn = event.target.closest('[data-bundle-toggle]');
    const add = event.target.closest('[data-bundle-add]');
    const remove = event.target.closest('[data-remove]');
    const qty = event.target.closest('[data-qty]');
    if (toggleBtn && isMobile()) {
      setPanelOpen(!panel.classList.contains('is-open'));
      return;
    }
    if (add) {
      const card = add.closest('[data-bundle-card]');
      const variant = readVariant(card);
      if (!card || !variant || !variant.available) return;
      const blockId = card.dataset.blockId;
      if (selected.has(blockId)) {
        selected.delete(blockId);
        add.textContent = root.dataset.labelAdd;
      } else {
        const image = card.querySelector('[data-card-image]');
        const required = Math.max(1, parseInt(card.dataset.requiredQuantity, 10) || 1);
        selected.set(blockId, {
          id: variant.id,
          price: variant.price,
          quantity: required,
          required,
          available: true,
          title: card.dataset.title,
          image: variant.image || (image ? image.currentSrc || image.src : '')
        });
      }
      if (error) error.hidden = true;
      render();
    }
    if (remove) {
      selected.delete(remove.dataset.remove);
      const card = root.querySelector(`[data-block-id="${remove.dataset.remove}"]`);
      const button = card ? card.querySelector('[data-bundle-add]') : null;
      if (button) button.textContent = root.dataset.labelAdd;
      if (error) error.hidden = true;
      render();
    }
    if (qty) {
      const item = selected.get(qty.dataset.blockId);
      if (!item) return;
      if (qty.dataset.qty === 'decrease') item.quantity = Math.max(item.required || 1, item.quantity - 1);
      if (qty.dataset.qty === 'increase') item.quantity = Math.min(10, item.quantity + 1);
      render();
    }
  });

  root.addEventListener('change', (event) => {
    if (!event.target.matches('[data-variant-select]')) return;
    const card = event.target.closest('[data-bundle-card]');
    paintCard(card);
    render();
  });

  submit.addEventListener('click', async () => {
    if (submit.disabled) return;
    const items = [];
    selected.forEach((item) => {
      if (item.available !== false && item.id) {
        items.push({ id: Number(item.id), quantity: Number(item.quantity) || 1 });
      }
    });
    if (!items.length) return;
    submit.dataset.loading = 'true';
    submit.disabled = true;
    if (submitLabel) submitLabel.textContent = root.dataset.labelAdding;
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    try {
      const response = await fetch(cartUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });
      const raw = await response.text();
      let data = null;
      try {
        data = raw ? JSON.parse(raw) : null;
      } catch (parseError) {
        data = null;
      }
      if (!response.ok) {
        throw new Error(
          (data && (data.description || data.message)) ||
          root.dataset.labelError ||
          'There was an error adding items to cart. Please try again.'
        );
      }
      await updateCartUi();
      openCartDrawer();
    } catch (cartError) {
      if (error) {
        error.hidden = false;
        error.textContent = cartError.message || root.dataset.labelError;
      }
    } finally {
      submit.dataset.loading = 'false';
      if (submitLabel) submitLabel.textContent = root.dataset.labelAddToCart || submitLabel.textContent;
      render();
    }
  });

  root.querySelectorAll('[data-bundle-card]').forEach((card) => {
    paintCard(card);
  });
  setPanelOpen(!isMobile());
  render();
};

const bootBundleBuilders = (scope) => {
  (scope || document).querySelectorAll('[data-bundle-builder]').forEach(initBundleBuilder);
};

bootBundleBuilders(document);
document.addEventListener('shopify:section:load', (event) => bootBundleBuilders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.shopLookMobileReady) return;
  window.shopLookMobileReady = true;

  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function activate(look, index, shouldScroll) {
    var items = look.querySelectorAll('.shop-the-look__mobile-item');
    if (!items.length || index < 0 || index >= items.length) return;

    items.forEach(function (item, itemIndex) {
      item.classList.toggle('is-selected', itemIndex === index);
    });

    if (!shouldScroll || !window.matchMedia('(max-width: 699px)').matches) return;
    if (!look.querySelector('.shop-the-look__carousel--stacked')) return;

    items[index].scrollIntoView({
      behavior: motionQuery.matches ? 'auto' : 'smooth',
      block: 'nearest'
    });
  }

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('.shop-the-look__dot');
    if (dot) {
      var group = dot.parentElement;
      var look = dot.closest('.shop-the-look');
      if (!group || !look) return;
      activate(look, Array.prototype.indexOf.call(group.children, dot), true);
      return;
    }

    if (event.target.closest('a, button, input, form, label')) return;

    var item = event.target.closest('.shop-the-look__mobile-item');
    if (!item) return;
    var cardLook = item.closest('.shop-the-look');
    if (!cardLook) return;
    var cardItems = cardLook.querySelectorAll('.shop-the-look__mobile-item');
    var cardIndex = Array.prototype.indexOf.call(cardItems, item);
    var mobileDots = cardLook.querySelector('page-dots');
    var matchingDot = mobileDots && mobileDots.children[cardIndex];
    if (matchingDot) matchingDot.click();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('[id^="effect-carousel-"] > div');
    if (!slide || !slide.parentElement) return;
    var look = slide.closest('.shop-the-look');
    if (!look) return;
    var index = Array.prototype.indexOf.call(slide.parentElement.children, slide);
    activate(look, index, false);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
